import account, { logout } from '@lib/auth/account'

export async function res2json(r) {
  if (r.status === 401) {
    if (account().username) {
      logout()
      document.location.reload()
    }
    return { status: 401, data: null }
  }
  if (r.status !== 204) {
    try {
      r.data = await r.json()
    } catch {
      console.error(await r.text().catch(() => ''))
      r.data = null
    }
  }
  return r
}
// 若要製作關於formatDateTime的方法，請到lib/utils/date.js查詢
